export default "__VITE_ASSET__1487c6bc__"